module.exports = __webpack_public_path__ + "img/goods_coupon_chiba04.173326cf.png";